"use strict";

exports.__esModule = true;
exports.PieChartAngleSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _helper = require("../../Widgets/MeasureChart/helper");
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _numericInputMinMaxSanitizer = require("../../../Utils/numericInputMinMaxSanitizer");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var MIN_ANGLE = 0;
var MAX_ANGLE = 360;
var PieChartAngleSelector = exports.PieChartAngleSelector = function PieChartAngleSelector(props) {
  var _chartItem$angle, _chartItem$angle2, _chartItem$angle3;
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var elementEditor = props.elementEditor,
    path = props.path,
    itemIndex = props.itemIndex,
    chartItem = props.chartItem;
  var angle = chartItem == null ? void 0 : chartItem.angle;
  var defaultStartAngle = 90;
  var defaultEndAngle = 90;
  (0, _react.useEffect)(function () {
    if (!angle || Object.entries(angle).length === 0) {
      elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].angle",
          value: el.props.chartItems.props[itemIndex].angle = {
            notFullCircle: false,
            startAngle: defaultStartAngle,
            endAngle: defaultEndAngle
          }
        };
      });
    }
  }, [angle, elementEditor, path, itemIndex]);
  return /*#__PURE__*/_react["default"].createElement(_helper.Well, {
    "data-testid": "PieChartAngleSelector"
  }, /*#__PURE__*/_react["default"].createElement(_helper.WellTitle, null, translate("PieChartAngleSelector.angleSettings.label", "Angle settings")), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("PieChartAngleSelector.angle.notFullCircle.label", "Show partial circle"),
    "data-testid": "PieChartAngleSelector.angle.notFullCircle.switch",
    checked: (_chartItem$angle = chartItem.angle) == null ? void 0 : _chartItem$angle.notFullCircle,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].angle.notFullCircle",
          value: el.props.chartItems.props[itemIndex].angle.notFullCircle = e.target.checked
        };
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("PieChartAngleSelector.angle.label", "Start and end angles"),
    style: {
      marginTop: "10px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    content: translate("PieChartAngleSelector.angle.startAngle.tooltip", "Start angle (from 00:00 position) moving left"),
    position: _core.Position.TOP
  }, /*#__PURE__*/_react["default"].createElement(_core.NumericInput, {
    "data-testid": "PieChartAngleSelector.angle.startAngle.input",
    min: MIN_ANGLE,
    max: MAX_ANGLE,
    style: {
      width: "45px"
    },
    onValueChange: function onValueChange(value) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].angle.startAngle",
          value: el.props.chartItems.props[itemIndex].angle.startAngle = (0, _numericInputMinMaxSanitizer.numericInputMinMaxSanitizer)(value, MIN_ANGLE, MAX_ANGLE)
        };
      });
    },
    value: ((_chartItem$angle2 = chartItem.angle) == null ? void 0 : _chartItem$angle2.startAngle) || defaultStartAngle
  })), /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    content: translate("PieChartAngleSelector.angle.endAngle.tooltip", "End angle (from 00:00 position) moving right"),
    position: _core.Position.TOP
  }, /*#__PURE__*/_react["default"].createElement(_core.NumericInput, {
    "data-testid": "PieChartAngleSelector.angle.endAngle.input",
    min: MIN_ANGLE,
    max: MAX_ANGLE,
    style: {
      width: "45px"
    },
    onValueChange: function onValueChange(value) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].angle.endAngle",
          value: el.props.chartItems.props[itemIndex].angle.endAngle = (0, _numericInputMinMaxSanitizer.numericInputMinMaxSanitizer)(value, MIN_ANGLE, MAX_ANGLE)
        };
      });
    },
    value: ((_chartItem$angle3 = chartItem.angle) == null ? void 0 : _chartItem$angle3.endAngle) || defaultEndAngle
  }))));
};